module.exports = "<h3>\n  <ng-content></ng-content>\n</h3>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/empty/empty-title/empty-title.component.html
// module id = ../../../../../src/app/shared/empty/empty-title/empty-title.component.html
// module chunks = 4